import { combineReducers } from "redux";
import userReducer from "./auth/slices/userSlice"; // User related slice
import registerReducer from "./driver/slices/registerDriverSlice"; // Driver registration slice
import validateTokenReducer from "./driver/slices/validateDriverInvitationSlice"; // Driver token validation slice
import inviteDriverSlice from "./driver/slices/inviteDriverSlice"; // Driver invitation slice
import deleteDriverSlice from "./driver/slices/deleteDriverSlice"; // Driver deletion slice
import updateDriverSlice from "./driver/slices/updateDriverSlice"; // Driver update slice
import getDriverReducer from "./driver/slices/getDriverSlice"; // Get drivers slice

import createCustomerSlice from "./customer/slices/createCustomerSlice"; // Customer creation slice
import updateCustomerSlice from "./customer/slices/updateCustomerSlice"; // Customer update slice
import deleteCustomerSlice from "./customer/slices/deleteCustomerSlice"; // Customer deletion slice
import getCustomerSlice from "./customer/slices/getCustomerSlice"; // Customer get slice

import createDepartmentSlice from "./department/slices/createDepartmentSlice"; // Department creation slice
import updateDepartmentSlice from "./department/slices/updateDepartmentSlice"; // Department update slice
import deleteDepartmentSlice from "./department/slices/deleteDepartmentSlice"; // Department deletion slice
import getDepartmentSlice from "./department/slices/getDepartmentSlice"; // Department get slice

import createDeliverySlice from "./package/slices/createDeliverySlice"; // Delivery creation slice
import cancelPackageSlice from "./package/slices/cancelPackageSlice"; // Package cancellation slice
import updatePackageSlice from "./package/slices/updatePackageSlice"; // Package update slice
import getDeliveryReducer from "./package/slices/getDeliverySlice"; // Get deliveries slice
import getCurrentDeliveriesReducer from "./package/slices/getCurrentDeliveriesSlice"; // Get current deliveries slice
import getDeliveryHistoryReducer from "./package/slices/getDeliveryHistorySlice"; // Get delivery history slice
import getDeliveriesByDate from "./package/slices/getDeliveriesByDateSlice"; // Get deliveries by date slice

import getVehiclesReducer from "./vehicle/slices/getVehicleSlice"; // Get vehicles slice

import searchReducer from "./misc/slices/searchSlice"; // Search slice
import reqPassReset from "./requestPassReset/reqPassReset";
import resetPass from "./resetPass/resetPass";
import setPackageFormSlice from "./forms/packageForm";
import globalFnSlice from "./globalFunctions/globalFnSlice";
import getDriverLocation from "./driver/slices/getDriverLocation";
import getIntegrationsSlice from "./integrations/getIntegrations";
import generateApiKeySlice from "./integrations/generateApiKey";
import fetchPackageProgressSlice from "./package/getPackageProgress";
import getCustomerDraftsSlice from "./integrations/getCustomerDrafts";
import deleteCustomerDraftSlice from "./integrations/deleteCustomerDraft";
import createVehicleSlice from "./vehicle/createVehicle";
import deleteVehicleSlice from "./vehicle/deleteVehicle";
import updateVehicleSlice from "./vehicle/updateVehicle";
import getScheduledDeliveriesSlice from "./package/scheduledPackages/getScheduledDeliveries";
import createScheduledDeliverySlice from "./package/scheduledPackages/createScheduledDelivery";
import deleteScheduledDeliverySlice from "./package/scheduledPackages/deleteScheduledDelivery";
import getPackagingListSlice from "./package/getPackagingList";
import setCustomerFormSlice from "./forms/customerForm";
import setDepartmentFormSlice from "./forms/departmentForm";
import setDriverFormSlice from "./forms/driverForm";
import setVehicleFormSlice from "./forms/vehicleForm";
import setApiKeyFormSlice from "./forms/apiKeyForm";
import updateScheduledDeliverySlice from "./package/scheduledPackages/updateScheduledDelivery";
import getCreatedScheduledByIdSlice from "./package/scheduledPackages/getCreatedScheduledById";

const appReducer = combineReducers({
  // User slices
  user: userReducer,
  resetPassReq: reqPassReset,
  resetPassword: resetPass,

  /*   driverRedux: combineReducers({}), */ // vaka preprajgi site grupirani da se
  // Driver related slices
  register: registerReducer,
  validateToken: validateTokenReducer,
  inviteDriver: inviteDriverSlice,
  deleteDriver: deleteDriverSlice,
  updateDriver: updateDriverSlice,
  drivers: getDriverReducer,
  driverLocation: getDriverLocation,
  packagingList: getPackagingListSlice,

  // Customer related slices
  createCustomer: createCustomerSlice,
  updateCustomer: updateCustomerSlice,
  deleteCustomer: deleteCustomerSlice,
  customers: getCustomerSlice,

  // Department related slices
  createDepartment: createDepartmentSlice,
  updateDepartment: updateDepartmentSlice,
  deleteDepartment: deleteDepartmentSlice,
  departments: getDepartmentSlice,

  // Package related slices
  createDelivery: createDeliverySlice,
  cancelDelivery: cancelPackageSlice,
  updatePackage: updatePackageSlice,
  currentDeliveries: getCurrentDeliveriesReducer,
  deliveryHistory: getDeliveryHistoryReducer,
  deliveriesByDate: getDeliveriesByDate,
  deliveries: getDeliveryReducer,
  getPackageProgress: fetchPackageProgressSlice,

  // Vehicle slices
  vehicles: getVehiclesReducer,

  // Search slice
  search: searchReducer,

  // Global functions slice
  global: globalFnSlice,

  // Integrations
  getIntegrations: getIntegrationsSlice,
  generateApiKey: generateApiKeySlice,
  getCustomerDrafts: getCustomerDraftsSlice,
  deleteCustomerDraft: deleteCustomerDraftSlice,

  // Vehicles
  createVehicle: createVehicleSlice,
  deleteVehicle: deleteVehicleSlice,
  updateVehicle: updateVehicleSlice,

  // Scheduled deliveries

  scheduledDeliveries: combineReducers({
    getScheduledDeliveries: getScheduledDeliveriesSlice,
    createScheduledDelivery: createScheduledDeliverySlice,
    deleteScheduledDelivery: deleteScheduledDeliverySlice,
    updateScheduledDelivery: updateScheduledDeliverySlice,
    getCreatedScheduledById: getCreatedScheduledByIdSlice,
  }),

  forms: combineReducers({
    customerForm: setCustomerFormSlice,
    departmentForm: setDepartmentFormSlice,
    driverForm: setDriverFormSlice,
    packageForm: setPackageFormSlice,
    vehicleForm: setVehicleFormSlice,
    apiKeyForm: setApiKeyFormSlice,
  }),
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STORE") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
